import { render, staticRenderFns } from "./chooseClass.vue?vue&type=template&id=7a1c168e&scoped=true"
import script from "./chooseClass.vue?vue&type=script&lang=js"
export * from "./chooseClass.vue?vue&type=script&lang=js"
import style0 from "./chooseClass.vue?vue&type=style&index=0&id=7a1c168e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1c168e",
  null
  
)

export default component.exports